import { render } from "./SecurityRisk.vue?vue&type=template&id=5838a57a&scoped=true"
import script from "./SecurityRisk.vue?vue&type=script&lang=js"
export * from "./SecurityRisk.vue?vue&type=script&lang=js"

import "./SecurityRisk.vue?vue&type=style&index=0&id=5838a57a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5838a57a"

export default script